import { useState, useEffect } from 'react';
import './Contact.css';

const Contact = () => {

    const [showPic, setShowPic] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {

        window.addEventListener('resize', handleWindowsSizeChange);

        return () => {
            window.removeEventListener('resize', handleWindowsSizeChange);
        }

    }, []);

    function handleWindowsSizeChange() {
        setWidth(window.innerWidth);
    }

    return (
        <div className={`contact-container${showPic ? ' pic-shown' : ''}`}>
            {width <= 768 ? (
                <div className='picture-mobile-contact'>
                    <img src={process.env.PUBLIC_URL + "/sebasfotos.jpg"} alt="sebas-foto" className='sebasfoto' />
                </div>
            ) : (
                showPic && (
                    <div className='picture-contact'>
                        <img src={process.env.PUBLIC_URL + "/sebasfotos.jpg"} alt="sebas-foto" className='sebasfoto' />
                    </div>
                )
            )}
            <div className='title'>
                MUSIC VIDEOS
            </div>
            <div className='music-videos-contact'>
                US<br />
                LAB, INC.<br />
                DOUG KLINGER<br />
                <a href='mailto:doug@labinc.info'>doug@labinc.info</a>
                <br />-<br />
                MANDEE MALLONE<br />
                <a href='mailto:mandee@labinc.info'>mandee@labinc.info</a>
            </div>
            <div className='title'>
                COMMERCIAL
            </div>
            <div className='music-videos-contact'>
                MEXICO<br />
                FUTURA<br />
                RODRIGO MENDOZA WALKER<br />
                <a href='mailto:rodrigo@futura.works'>rodrigo@futura.works</a>
                <br /><br />
                COSTA RICA<br />
                REELAX<br />
                GUSTAVO JIMENEZ<br />
                <a href='mailto:gustavo@reelaxmedia.com'>gustavo@reelaxmedia.com</a>
            </div>
            <div className="email-block">
                <div className='me'>
                    ME
                </div>
                {width <= 768 ? (
                    <a href="mailto:sebas@estudiodenine.com">
                        sebas@estudiodenine.com
                    </a>
                ) : (
                    <a href="mailto:sebas@estudiodenine.com" onMouseEnter={() => setShowPic(true)} onMouseLeave={() => setShowPic(false)}>
                        sebas@estudiodenine.com
                    </a>
                )}
            </div>
            <div className='social-networks'>
                <div className="instagram-logo">
                    <a href="https://www.instagram.com/sebas.coto/" target="_blank" rel="noreferrer">
                        <img src={process.env.PUBLIC_URL + "/instagramlogo.png"} alt="instagram" id="instagram-logo" className='logo' />
                    </a>
                </div>
                <div className="vimeo-logo">
                    <a href="https://vimeo.com/sebascoto" target="_blank" rel="noreferrer">
                        <img src={process.env.PUBLIC_URL + "/vimeologo.png"} alt="instagram" className="logo" />
                    </a>
                </div>
                <div className="nova-logo">
                    <a href="https://www.itsnova.com/sebascoto" target="_blank" rel="noreferrer">
                        <img src={process.env.PUBLIC_URL + "/novalogo.png"} alt="instagram" className="logo" />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Contact;